import React from "react"
import PrivacyPolicyTemplate from "../../components/PrivacyPolicyTemplate/PrivacyPolicyTemplate"


const PrivacyPolicy = ({ data }) => {
    const row = {
        title: "CCPA Privacy Policy",
        contents: []
    }

    return (
        <PrivacyPolicyTemplate row = { row } data = { data }/>
    )
}

export default PrivacyPolicy